import React, { useEffect, useState } from "react"
import styled from "styled-components"
// POLISH LETTERS
import ALetter from "../../assets/letters/a_wolontariat.svg"
import ALetterSecond from "../../assets/letters/a_wolontariat_second.svg"
import TLetter from "../../assets/letters/t_wolontariat_v22.svg"
import WLetter from "../../assets/letters/w_wolontariat.svg"
import OLetter1 from "../../assets/letters/o_wolontariat.svg"
import LLetter from "../../assets/letters/l_wolontariat.svg"
import NLetter from "../../assets/letters/n_wolontariat.svg"
import OLetterSecond from "../../assets/letters/o_wolontariat_second.svg"
import RILetter from "../../assets/letters/r-i_wolontariat.svg"
import TLetterFirst from "../../assets/letters/t_wolontariat_first.svg"
// import PckLogo from '../../assets/images/logo-pck.svg';
// import PckLogo from '../../assets/images/logo_pck_new.svg';
// ENGLISH LETTERS
import VLetterEn from "../../assets/letters_en/v_wolontariat_1.svg"
import OLetterEn from "../../assets/letters_en/o_wolontariat.svg"
import LLetterEn from "../../assets/letters_en/l_wolontariat_1.svg"
import ULetterEn from "../../assets/letters_en/u_wolontariat.svg"
import NLetterEn from "../../assets/letters_en/n_wolontariat_1.svg"
import TLetterEn from "../../assets/letters_en/t_wolontariat.svg"
import ELetterEn from "../../assets/letters_en/e_wolontariat_1.svg"
import ELetterEnSecond from "../../assets/letters_en/e_wolontariat_2.svg"
import RILetterEn from "../../assets/letters_en/r-i_wolontariat_1.svg"
import NLetterEnSecond from "../../assets/letters_en/n_wolontariat_2.svg"
import GLetterEn from "../../assets/letters_en/g_wolontariat.svg"
import IconSnap from "../../assets/icon_snap.svg"
import IconRestore from "../../assets/icon_restore.svg"
import IconBreak from "../../assets/icon_break.svg"
import { Draggable, gsap, useGSAP } from "@/utils/gsap"
import { useViewportWidth } from "@/hooks/useViewport"
import { useIsDesktop, useIsMobile, useIsTablet } from "@/hooks/useDevice"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { useRouter } from "next/router"
import Button from "@/components/common/Buttons/Button"
import CommonIcon from "@/components/common/Icon/Icon"
import { BUTTON_VARIANTS, ICONS } from "@/constants"
import SingleActionButton from "@/components/draggableLetters/SingleActionButton"
import useScrollContext from "@/hooks/useScrollContext"
import { parseDatoText } from "@/utils/utils"

const letters = [
	<WLetter key="w" />,
	<OLetter1 key="o1" />,
	<LLetter key="l" />,
	<OLetterSecond key="o2" />,
	<NLetter key="n" />,
	<TLetterFirst key="t1" />,
	<ALetter key="a1" />,
	<RILetter key="ri" />,
	<ALetterSecond key="a2" />,
	<TLetter key="t" />,
]

const lettersEn = [
	<VLetterEn key="v" />,
	<OLetterEn key="o" />,
	<LLetterEn key="l" />,
	<ULetterEn key="u" />,
	<NLetterEn key="n1" />,
	<TLetterEn key="t" />,
	<ELetterEn key="e1" />,
	<ELetterEnSecond key="e2" />,
	<RILetterEn key="ri" />,
	<NLetterEnSecond key="n2" />,
	<GLetterEn key="g" />,
]

const DraggableLettersContainer = styled.div`
	width: 100%;
	//height: 100vh;
	position: relative;
	background-color: ${({ theme }) => theme.colors.white};
	//background-color: #F5E7DD;
`

const InnerWrapper = styled.div`
	width: 100%;
	border: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
	border-bottom-width: 0;
	border-right-width: 0;
	display: flex;
	flex-direction: row;
	position: relative;

	&.grid {
		display: grid;
		grid-template-columns: repeat(8, 1fr);
		grid-template-rows: repeat(7, 1fr);
		@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
			grid-template-columns: repeat(16, 1fr);
			grid-template-rows: repeat(7, 1fr);
		}
	}

	.grid-item {
		aspect-ratio: 1;
		border-bottom: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
		border-right: 1px solid ${({ theme }) => theme.colors.antiflashWhite};
	}
`

const SingleLetterWrapper = styled.div`
	width: calc(100vw / 8);
	height: calc(100vw / 8);
	position: absolute;
	z-index: 1;
	top: ${({ elementIndex }) => (elementIndex < 5 ? "calc(7 * (100vw / 8))" : "calc(8 * (100vw / 8))")};
	left: ${({ elementIndex, shiftOffset }) =>
		elementIndex < 5
			? `calc((${shiftOffset} * (100vw / 8)) + ${elementIndex} * (100vw / 8))`
			: `calc((${shiftOffset} * (100vw / 8)) + ${elementIndex - 6} * (100vw / 8))`};
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		top: ${({ elementIndex }) => (elementIndex < 5 ? "calc(3 * (100vw / 8))" : "calc(4 * (100vw / 8))")};
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: calc(100vw / 16);
		height: calc(100vw / 16);
		top: ${({ elementIndex }) => (elementIndex < 5 ? "calc(2 * (100vw / 16))" : "calc(3 * (100vw / 16))")};
		left: ${({ elementIndex, shiftOffset }) =>
			elementIndex < 5
				? `calc((${shiftOffset} * (100vw / 16)) + ${elementIndex} * (100vw / 16))`
				: `calc((${shiftOffset} * (100vw / 16)) + ${elementIndex - 6} * (100vw / 16))`};
	}

	&.logo {
		left: unset;
		right: 0;
		top: 240px;
		border: 2px solid ${({ theme }) => theme.colors.chineseViolet};
	}
`

const ActionsButtonsWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.antiflashWhite};
	position: absolute;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: calc(100vw / 8);
	height: calc(100vw * 3 / 8);
	//bottom: calc(100vw / 12);
	bottom: unset;
	top: calc(100vw * 4 / 8);
	right: 0;
	padding: calc(100vw / (16 * 4)) 0;
	z-index: 1015;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: calc(100vw / 8);
		height: calc(100vw * 2 / 8);
		bottom: unset;
		top: calc(100vw * 7 / 8);
		right: 0;
		padding: calc(100vw / (16 * 4)) 0;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: calc(100vw / 16);
		height: calc(100vw / 8);
		bottom: calc(100vw / 16);
		top: unset;
		right: calc(100vw / 16);
		padding: calc(100vw / (16 * 4)) 0;
	}
`

const ActionsButtonsInnerWrapper = styled.div`
	width: 80%;
	//border: 1px solid ${({ theme }) => theme.colors.richBlack};
	display: flex;
	flex-direction: column;
	justify-content: center;
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		width: 57%;
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		width: 50%;
	}
`

const NavigationButtonContainer = styled.div`
	position: absolute;
	bottom: calc(100vw * 3 / 8);
	left: calc(100vw / 8);
	height: calc(100vw / 8);
	width: calc(100vw * 6 / 8);

	button {
		width: 100%;
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.TABLET]}px) {
		bottom: calc(100vw * 4 / 8);
		left: calc(100vw / 8);
		height: auto;
		width: unset;
		button {
			width: fit-content;
		}
	}
	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		bottom: calc(100vw / 16);
		left: calc(100vw / 8);
	}
`

const Icon = styled(CommonIcon)`
	height: 22px;
	width: 22px;
	margin-left: 10px;
	transform: rotate(90deg);

	svg {
		path {
			fill: ${({ theme }) => theme.colors.white};
		}
	}
`

const HiddenHeading1 = styled.h1`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;
	clip: rect(0 0 0 0);
	border: 0;
	white-space: nowrap;
`

const DraggableLetters = ({ data }) => {
	const { locale } = useRouter()
	const viewportWidth = useViewportWidth()
	const isDesktop = useIsDesktop()
	const isTablet = useIsTablet()
	const isMobile = useIsMobile()
	const buttonText = data?.buttonText || ""
	const scrollToId = data?.scrollTo?.id || ""
	const divider = isDesktop ? 16 : 8
	const [finalLettersSource, setFinalLettersSource] = useState(letters)
	const [singleGridItemSize, setSingleGridItemSize] = useState(viewportWidth / divider)
	const [isSnapActive, setIsSnapActive] = useState(true)
	const [isInitialState, setIsInitialState] = useState(true)
	const [isLettersCrush, setIsLettersCrush] = useState(false)
	const scroll = useScrollContext()
	const columnsNumber = isMobile || isTablet ? 8 : 16
	const crushYIf = (100 * 4) / columnsNumber + "vw"
	const crushYElse = (100 * 3) / columnsNumber + "vw"
	useEffect(() => {
		const source = locale === "pl" ? letters : lettersEn
		setFinalLettersSource(source)
	}, [locale])
	useEffect(() => {
		setSingleGridItemSize(viewportWidth / divider)
	}, [viewportWidth, isDesktop, divider])
	useGSAP(
		() => {
			if (viewportWidth > 0) {
				finalLettersSource.forEach((item, key) => {
					const id = `#letter-${key + 1}`
					Draggable.create(id, {
						type: "x,y",
						onThrowUpdate: () => {
							if (isInitialState) {
								setIsInitialState(false)
							}
						},
						// bounds: "#container",
						bounds: document.getElementById("container"),
						inertia: true,
						snap: isSnapActive
							? {
									x: function (value) {
										return Math.round(value / singleGridItemSize) * singleGridItemSize
									},
									y: function (value) {
										return Math.round(value / singleGridItemSize) * singleGridItemSize
									},
								}
							: false,
					})
				})
				if (isLettersCrush) {
					const items = document.querySelectorAll(".crush-animation")
					items.forEach((item, index) => {
						gsap.to(item, {
							duration: 1.15,
							// y: index < 5 ? '25vw' : '18.75vw', // 16 / 4 i 16 / 3
							y: index < 5 ? crushYIf : crushYElse, // 16 / 4 i 16 / 3
							// rotateZ: index < 5 ? '40deg' : '-30deg',
							rotateZ: index % 3 === 1 ? index * 7 + 40 : index * 10 - 30,
							ease: "bounce.out",
						})
					})
				}
				// Draggable.create("#element", {
				// 	type: "x,y",
				// 	// bounds: "#container",
				// 	bounds: document.getElementById("container"),
				// 	inertia: true,
				// 	snap: {
				// 		x: function (value) {
				// 			return Math.round(value / 175) * 175;
				// 		},
				// 		y: function (value) {
				// 			return Math.round(value / 175) * 175;
				// 		}
				// 	}
				// });
				// Draggable.create("#element2", {
				// 	type: "x,y",
				// 	// bounds: "#container",
				// 	bounds: document.getElementById("container"),
				// 	inertia: true,
				// 	snap: {
				// 		x: function (value) {
				// 			return Math.round(value / 175) * 175;
				// 		},
				// 		y: function (value) {
				// 			return Math.round(value / 175) * 175;
				// 		}
				// 	}
				// });
				// Draggable.create("#logo", {
				// 	type: "rotation",
				// 	// bounds: "#container",
				// 	// bounds: {
				// 	// 	minRotation: 0,
				// 	// 	maxRotation: 180
				// 	// }
				// 	inertia: true,
				// 	snap: {
				// 		rotation: function(value) {
				// 			return Math.round(value / 90) * 90;
				// 		}
				// 	}
				// });
				setIsInitialState(false)
			}
		},
		{
			dependencies: [
				viewportWidth,
				isDesktop,
				divider,
				singleGridItemSize,
				isSnapActive,
				isInitialState,
				isLettersCrush,
				finalLettersSource,
			],
			revertOnUpdate: true,
		},
	)
	const handleButtonClick = () => {
		const target = document.getElementById(`${scrollToId}`)
		if (target) {
			scroll.scrollTo({
				top: target,
				offset: -80,
				behavior: "smooth",
			})
		}
	}
	const rectanglesAmount = isMobile ? 128 : 112
	return (
		<DraggableLettersContainer>
			<HiddenHeading1>{parseDatoText(data?.buttonText || "")}</HiddenHeading1>
			<InnerWrapper className="grid" id="container">
				{finalLettersSource.map((item, key) => {
					const id = `letter-${key + 1}`
					const elementIndex = key
					const mobileShiftOffset = key < 5 ? 1 : 3
					const desktopShiftOffset = key < 5 ? 4 : 8
					const shiftOffset = !isMobile && !isTablet ? desktopShiftOffset : mobileShiftOffset
					return (
						<SingleLetterWrapper
							id={id}
							key={id}
							className={isLettersCrush ? "crush-animation" : ""}
							// rotation={(Math.random() * 100).toFixed()}
							// rotation={0}
							elementIndex={elementIndex}
							shiftOffset={shiftOffset}
						>
							{item}
						</SingleLetterWrapper>
					)
				})}
				{/*<SingleLetterWrapper className='over-logo'>*/}
				{/*	<p className='typo-borna typo-borna-11'>Obróć logo</p>*/}
				{/*</SingleLetterWrapper>*/}
				{/*<SingleLetterWrapper className='logo' id='logo'>*/}
				{/*	<PckLogo/>*/}
				{/*</SingleLetterWrapper>*/}
				{/*{[...new Array(112)].map((_, key) => <div className='grid-item' key={`block-${key}`}/>)}*/}
				{[...new Array(rectanglesAmount)].map((_, key) => (
					<div className="grid-item" key={`block-${key}`} />
				))}
				<ActionsButtonsWrapper>
					<ActionsButtonsInnerWrapper>
						<SingleActionButton className={isSnapActive ? "active" : ""} onClick={() => setIsSnapActive(!isSnapActive)}>
							<IconSnap />
						</SingleActionButton>
						<SingleActionButton
							onClick={() => {
								setIsLettersCrush(false)
								setIsInitialState(!isInitialState)
							}}
						>
							<IconRestore />
						</SingleActionButton>
						<SingleActionButton
							onClick={() => {
								setIsLettersCrush(true)
							}}
						>
							<IconBreak />
						</SingleActionButton>
					</ActionsButtonsInnerWrapper>
				</ActionsButtonsWrapper>
				<NavigationButtonContainer>
					<Button onClick={handleButtonClick} variant={BUTTON_VARIANTS.PRIMARY}>
						{buttonText}
						<Icon name={ICONS.CHEVRON} />
					</Button>
				</NavigationButtonContainer>
			</InnerWrapper>
		</DraggableLettersContainer>
	)
}

export default DraggableLetters
